export const MapViewImage = {
  GET_MAP_VIEW_IMAGE: "GET_MAP_VIEW_IMAGE",
  GET_MAP_VIEW_IMAGE_SUCCESS: "GET_MAP_VIEW_IMAGE_SUCCESS",
  GET_MAP_VIEW_IMAGE_FAILURE: "GET_MAP_VIEW_IMAGE_FAILURE",

  DOWNLOAD_MAP_IMAGE: "DOWNLOAD_CITY_SUMMARY_MAP_IMAGE",
  DOWNLOAD_MAP_IMAGE_SUCCESS: "DOWNLOAD_CITY_SUMMARY_MAP_IMAGE_SUCCESS",
  DOWNLOAD_MAP_IMAGE_FAILURE: "DOWNLOAD_CITY_SUMMARY_MAP_IMAGE_FAILURE",
};
